import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import DataTableRepository from '../Repositories/DataTableRepository'

class DataTableBloc {
    
    rowtableChannel = new Subject();
    inactiveChannel = new Subject();
    activeChannel = new Subject();
    detailChannel = new Subject();
    createChannel = new Subject();
    updateChannel = new Subject();
    deleteChannel = new Subject();
    optionChannel = new Subject();

    repository = new DataTableRepository();

    constructor() {
        this.rowtableChannel.next({ status: apiResponse.INITIAL });
        this.inactiveChannel.next({ status: apiResponse.INITIAL });
        this.activeChannel.next({ status: apiResponse.INITIAL });
        this.detailChannel.next({ status: apiResponse.INITIAL });
        this.createChannel.next({ status: apiResponse.INITIAL });
        this.updateChannel.next({ status: apiResponse.INITIAL });
        this.deleteChannel.next({ status: apiResponse.INITIAL });
        this.optionChannel.next({ status: apiResponse.INITIAL });
    }

    fetchOption = async (query) => {
        this.optionChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchOption(query).then((result) => {
            this.optionChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.optionChannel.next({status: apiResponse.ERROR, data: error})
        })
    }


    fetchRowTable = async (query, cancelToken) => {
        this.rowtableChannel.next({ status: apiResponse.LOADING });
        await this.repository.fetchRowTable(query, cancelToken).then((result) => {
            this.rowtableChannel.next({ status: apiResponse.COMPLETED, data: result });
        }).catch((error) => {
            this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    }

    fetchInactive = async (query) => {
        this.inactiveChannel.next({ status: apiResponse.LOADING });
        await this.repository.fetchInactive(query).then((result) => {
            this.inactiveChannel.next({ status: apiResponse.COMPLETED, data: result });
        }).catch((error) => {
            this.inactiveChannel.next({ status: apiResponse.ERROR, data: error });
        });
    }

    fetchActive = async (query) => {
        this.activeChannel.next({ status: apiResponse.LOADING });
        await this.repository.fetchActive(query).then((result) => {
            this.activeChannel.next({ status: apiResponse.COMPLETED, data: result });
        }).catch((error) => {
            this.activeChannel.next({ status: apiResponse.ERROR, data: error });
        });
    }

    fetchDetail = async (uuid) => {
        this.detailChannel.next({ status: apiResponse.LOADING });
        await this.repository.fetchDetail(uuid).then((result) => {
            this.detailChannel.next({ status: apiResponse.COMPLETED, data: result });
        }).catch((error) => {
            this.detailChannel.next({ status: apiResponse.ERROR, data: error });
        });
    }

    fetchCreate = async (data) => {
        this.createChannel.next({ status: apiResponse.LOADING });
        await this.repository.fetchCreate(data).then((result) => {
            this.createChannel.next({ status: apiResponse.COMPLETED, data: result });
        }).catch((error) => {
            this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    }

    fetchUpdate = async (data) => {
        this.updateChannel.next({ status: apiResponse.LOADING });
        await this.repository.fetchUpdate(data).then((result) => {
            this.updateChannel.next({ status: apiResponse.COMPLETED, data: result });
        }).catch((error) => {
            this.updateChannel.next({ status: apiResponse.ERROR, data: error });
        });
    }

    fetchDelete = async (query) => {
        this.deleteChannel.next({ status: apiResponse.LOADING });
        await this.repository.fetchDelete(query).then((result) => {
            this.deleteChannel.next({ status: apiResponse.COMPLETED, data: result });
        }).catch((error) => {
            this.deleteChannel.next({ status: apiResponse.ERROR, data: error });
        });
    }
}

export default DataTableBloc
